<div class="container contentHeight">
  <h3 class="text-left containerTitle" [translate]="'actionmateriel.support'"></h3>
  <div class="row lonelyStuff mx-auto d-flex actions justify-content-center">
    <!--justify-content-center-->
    <!-- Action 1 Formulaire de contact -->
    <div class="col-lg-4 col-md-6 col-sm-4 mt-3 box action ">
      <div class="cardAction backgroundWhiteRound" routerLink="/contact">
        <div class="text-dark text-center textAction">
          <i  aria-hidden="true" class="fal fa-envelope-open-text fa-3x  textIcon"></i>
          <!--<i  aria-hidden="true" class="fal fa-file-alt fa-3x  textIcon"></i>-->
          <p class="mt-2" [translate]="'assistance.form'"></p>
        </div>
      </div>
    </div>

    <!-- Action 2 Tchat -->
    <!-- @Caroline -> enlever la condition isTchat-->
    <div *ngIf="isTchat" class="col-lg-4 col-md-6 col-sm-4 mt-3 box action">
      <div class="cardActionAssistance cardAction backgroundWhiteRound " (click)="createConversation()">
        <div class="text-dark text-center textActionAssistance textAction">
          <i  aria-hidden="true" class="fal fa-comments-alt fa-3x textIcon"></i>
          <p class="mt-2" [translate]="'assistance.tchat'"></p>
        </div>
      </div>
    </div>

    <!--Action 3 Historique des demandes d'assistance --><!--routerLink="/histo"-->
    <!--<div class="col-lg-4 col-md-6 col-sm-6 mt-3 box action ">
    <div class="cardActionAssistance cardAction backgroundWhiteRound overlay">
      <div class="text-dark text-center textActionAssistance textAction ">
        <i  aria-hidden="true" class="fal fa-history fa-3x textIcon"></i>
        <p class="mt-2" [translate]="'assistance.histo'"></p>
      </div>
    </div>
  </div>-->

    <!-- Action 4 Planning-->
    <div class="col-lg-4 col-md-6 col-sm-4 mt-3 box action" *ngIf="Utils.isCTC(role)">
      <!--*ngIf="Utils.isCTC(role) || Utils.isUserIxell(role) "-->
      <div class="cardActionAssistance cardAction backgroundWhiteRound" routerLink="/planning">
        <div class="text-dark text-center textActionAssistance textAction ">
          <i  aria-hidden="true" class="fal fa-calendar-alt fa-3x  textIcon"></i>
          <p [translate]="'planning.planningRDV'"></p>
        </div>
      </div>
    </div>

  </div>
</div>
